@if (safeUrl()) {
  <div class="overflow-hidden rounded-xl border border-slate-200 bg-black shadow-sm">
    <video
      [src]="safeUrl()"
      controls
      preload="metadata"
      class="w-full max-h-90"
      playsinline
    ></video>
    @if (caption()) {
      <div class="px-3 py-2 border-t border-slate-700 bg-slate-900">
        <p class="text-sm text-slate-300">{{ caption() }}</p>
      </div>
    }
  </div>
} @else {
  <div class="flex items-center gap-2 rounded-lg bg-slate-100 px-4 py-3 border border-slate-200">
    <i class="bi bi-film text-slate-400 text-lg"></i>
    <span class="text-sm text-slate-500">Video no disponible</span>
  </div>
}
